import { Flex, useDisclosure } from "@chakra-ui/react";
import AddUserModal from "@root/components/Admin/addusermodal";
import { StyledAdminLayoutParent } from "@root/components/adminDashboard/style";
import { CustomDrawer } from "@root/components/common/drawer";
import { CustomLoader } from "@root/components/common/loaders/CustomLoader";
import { CustomPopup } from "@root/components/common/modals/CustomPopup";
import DrawerFlow from "@root/components/filemanagement.tsx/drawer";
import { DeactivatePopup } from "@root/components/userMangement/components";
import { Headers } from "@root/components/userMangement/components/headers";
import {
  UserDetailsDrawer,
  UserProfileFooter,
} from "@root/components/userMangement/drawers/userDetails";
import { UserMangementFilters } from "@root/components/userMangement/filters/filters";
import { UserManageMainTable } from "@root/components/userMangement/tables/mainTable";
import useAdminUsers from "@root/hooks/useAdminUsers";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const AdminUserManagementScreen = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isDrawerFlowOpen, setIsDrawerFlowOpen] = useState(false);
  const { t } = useTranslation("common");
  const {
    adminUsers,
    loading,
    userManagementHeader,
    onPageChange,
    page,
    count,
    setPage,
    onInputChange,
    onDateChange,
    onStatusChange,
    currentStatus,
    addUsers,
    userStatuses,
    search,
    onViewDetails,
    userDetailsDrawer,
    setUserDetailsDrawer,
    onDeactivateUser,
    deactivatePopup,
    setdeactivatePopup,
    deactivationLoading,
    lastLoginDates,
    drawerUser,
    fetchUsers,
  } = useAdminUsers();

  function handleAddUser(user: { email: string; name: string }): void {
    const payload = {
      email: user.email,
      fullname: user.name,
      roleId: 1,
    };
    addUsers(payload);
  }

  function openDrawer() {
    setIsDrawerFlowOpen(true);
    
  }

  return (
    <StyledAdminLayoutParent>
      <Flex flexDir={"column"} gap={"16px"}>
        <Headers
          title={t("admin.userManagement")}
          subheading={t("admin.subtext")}
          onAdd={onOpen}
          onDrawerOpen={openDrawer}
        />
        {isDrawerFlowOpen && (
          <DrawerFlow onClose={() => setIsDrawerFlowOpen(false)} />
        )}
        <AddUserModal
          isOpen={isOpen}
          onClose={onClose}
          onAddUser={handleAddUser}
        />
        <UserMangementFilters
          inputPlaceholder={t("usersManagement.searchByUserNameOrID")}
          statusPlaceholder={t("userManagement.selectStatus")}
          onInputChange={onInputChange}
          onDateChange={onDateChange}
          onStatusChange={onStatusChange}
          currentStatus={currentStatus}
          userStatuses={userStatuses}
          search={search}
          lastLoginDates={lastLoginDates}
        />
        {loading ? (
          <CustomLoader />
        ) : (
          <UserManageMainTable
            tableHeaders={userManagementHeader}
            tableItems={adminUsers}
            onViewDetails={onViewDetails}
            onPageChange={onPageChange}
            currentPage={page}
            count={count}
            setCurrentPage={setPage}
          />
        )}
      </Flex>
      <CustomDrawer
        open={userDetailsDrawer}
        onClose={() => setUserDetailsDrawer(false)}
        title={t("admin.userDetails")}
        footer={
          <UserProfileFooter
            onClose={() => {
              setUserDetailsDrawer(false);
              fetchUsers({ page: page });
            }}
            is_active={drawerUser?.is_active}
            onDeactivate={() => setdeactivatePopup(true)}
            loading={deactivationLoading}
          />
        }
      >
        <UserDetailsDrawer user={drawerUser} />
      </CustomDrawer>

      <CustomPopup
        open={deactivatePopup}
        onClose={() => setdeactivatePopup(false)}
        children={
          <DeactivatePopup
            is_active={drawerUser?.is_active}
            loading={deactivationLoading}
            onYes={onDeactivateUser}
            onNo={() => setdeactivatePopup(false)}
          />
        }
        title={t("userManagement.deactivation")}
        borderRadius={"16px"}
        bodyPadding="0px"
        maxH={"80vh"}
      />
    </StyledAdminLayoutParent>
  );
};
